import { createTheme, alpha } from '@mui/material/styles';

// Flat Material Design dark theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00D4AA',
      light: '#33DDBB',
      dark: '#00A080',
    },
    secondary: {
      main: '#FF6B6B',
      light: '#FF8E8E',
      dark: '#E55555',
    },
    background: {
      default: '#0A0E14',
      paper: '#131920',
    },
    text: {
      primary: '#E6EDF3',
      secondary: '#8B949E',
    },
    success: {
      main: '#10b981',
      light: '#34d399',
    },
    error: {
      main: '#ef4444',
    },
    warning: {
      main: '#f59e0b',
    },
    divider: alpha('#E6EDF3', 0.08),
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    body1: {
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontWeight: 400,
      lineHeight: 1.5,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: `
            radial-gradient(ellipse at 20% 0%, ${alpha('#00D4AA', 0.06)} 0%, transparent 50%),
            radial-gradient(ellipse at 80% 100%, ${alpha('#FF6B6B', 0.04)} 0%, transparent 50%)
          `,
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid ${alpha('#E6EDF3', 0.06)}`,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid ${alpha('#E6EDF3', 0.08)}`,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: alpha('#00D4AA', 0.3),
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: alpha('#131920', 0.8),
            '& fieldset': {
              borderColor: alpha('#E6EDF3', 0.1),
            },
            '&:hover fieldset': {
              borderColor: alpha('#00D4AA', 0.3),
            },
            '&.Mui-focused fieldset': {
              borderColor: '#00D4AA',
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          border: `1px solid ${alpha('#E6EDF3', 0.1)}`,
        },
        listbox: {
          maxHeight: 300,
        },
      },
    },
  },
});

export default theme;
